import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';

interface SuccessModalProps {
  show: boolean;
  title?: string;
  message?: string;
  onClose?: () => void;
  closeLabel?: string;
  closeDelay?: number; // Auto-close after this many ms
}

const SuccessModal = ({
  show,
  title = 'Success!',
  message = 'Operation completed successfully',
  onClose,
  closeLabel = 'Close',
  closeDelay = 0
}: SuccessModalProps) => {
  // Auto-close modal after specified delay
  if (closeDelay > 0 && show && onClose) {
    const timer = setTimeout(() => {
      onClose();
    }, closeDelay);

    return (
      <Modal show={show} onHide={onClose} centered backdrop="static" keyboard={false}>
        <Modal.Body className="p-4">
          <div className="text-center">
            <div className="mb-3">
              <FontAwesomeIcon icon={faCheckCircle} className="fs-3 text-success" />
            </div>
            <h5 className="fw-semibold mb-2">{title}</h5>
            <p className="text-body-tertiary mb-3">{message}</p>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Body className="p-4">
        <div className="text-center">
          <div className="mb-3">
            <FontAwesomeIcon icon={faCheckCircle} className="fs-3 text-success" />
          </div>
          <h5 className="fw-semibold mb-2">{title}</h5>
          <p className="text-body-tertiary mb-4">{message}</p>
          {onClose && (
            <div className="d-flex justify-content-center">
              <Button variant="phoenix-primary" onClick={onClose}>
                {closeLabel}
              </Button>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
